<template>
    <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h3>
                  Cambiar Clave de Acceso                  
                </h3>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="password"
                    class="form-control"
                    placeholder="Contraseña Actual"
                    autocomplete="current-password"
                    v-model="payload.actual"                    
                  />
                </b-input-group>
                <hr>
                <h5>Genere una nueva Clave de Acceso</h5>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="password"
                    class="form-control"
                    placeholder="Nueva Contraseña"
                    autocomplete="current-password"
                    v-model="payload.nueva"
                    :state="payload.nueva.length > 0 ? payload.nueva.length >= 8: null"
                  />
                </b-input-group>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="password"
                    class="form-control"
                    placeholder="Repita Contraseña"
                    autocomplete="current-password"
                    v-model="payload.nueva_confirmation"
                    :state="payload.nueva_confirmation.length > 0 ? payload.nueva_confirmation.length >= 8: null"
                  />
                </b-input-group>
                <b-row>
                  <b-col class="text-right">
                    <b-button variant="primary" class="px-4 btn-action" @click="cambiarClave()">
                      <i class="fa fa-check"></i> Aceptar
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            payload: {
                cod_agente: 0,
                actual: '',
                nueva: '',
                nueva_confirmation: ''
            }
        }
    },
    methods: {
        cambiarClave(){
            let userauth = JSON.parse(sessionStorage.getItem('auth'))
            this.payload.cod_agente = userauth.cod_agente?userauth.cod_agente:userauth.email;
            if(this.payload.nueva.length == 0){
                this.$toast.error('La clave no puede ser nula.', 'Error');
                return;
            }
            if(this.payload.nueva != this.payload.nueva_confirmation){              
                this.$toast.error('La confirmacion de contraseña no es correcta.', 'Error');
            }else{
                if (this.payload.actual == this.payload.nueva){              
                  this.$toast.error('La contraseña nueva no puede ser igual a la actual.', 'Error');
                  return;
                }
                let loading = this.$loading.show();
                this.$api.post('auth/changepassword', this.payload)
                    .then(r => {
                        this.$toast.success('Clave modificada con exito.', 'Exito');                        
                        loading.hide();
                        this.$router.push('/');
                    })
                    .catch( e => {
                       this.$toast.error(e.response.data.message, 'Error');     
                       loading.hide();
                    })
            }         
        }
    }
}
</script>